import { FC } from 'react';

import styles from './styles.module.scss';

export const Divider: FC = () => <span className={styles.divider} />;
